module.exports = __webpack_public_path__ + "img/litloyal-demo2.049ab61a.png";